// Styled components
import styled from '@emotion/styled';
import { colors, typography } from '../../../themes';
import { type StepperStatus } from './index';

const transition = 'transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);';

export const StepperContainer = styled.nav``;

export const StepperList = styled.ol`
  display: flex;
  justify-content: space-between;
  align-items: start;
  position: relative;
  list-style: none;
`;

export const Connector = styled.div<{ steps: number }>`
  height: 2px;
  position: absolute;
  top: 11px;
  right: calc(100% / (2 * ${({ steps }) => steps}));
  left: calc(100% / (2 * ${({ steps }) => steps}));
  z-index: 0;
  background: repeating-linear-gradient(
    90deg,
    ${colors.primary.blueTint2} 0 6px,
    transparent 6px 8px
  );
`;

export const ActiveConnector = styled.div<{ currentStep: number; steps: number }>`
  height: 100%;
  background-color: ${colors.primary.blueTint2};
  width: ${({ currentStep, steps }) => `${(currentStep / (steps - 1)) * 100}%`};
  ${transition}
`;

export const Step = styled.li`
  align-items: center;
  flex-direction: column;
  flex: 1;
  display: flex;
  z-index: 10;
  position: relative;
`;

export const StepButton = styled.button<{ status: StepperStatus }>`
  color: ${colors.base.white};
  background-color: ${({ status }) => {
    switch (status) {
      case 'done':
      case 'current':
      case 'skipped':
        return colors.primary.blue;
      case 'todo':
      default:
        return colors.primary.blueTint2;
    }
  }};
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  border: none;
  ${transition}

  &:focus {
    outline: 2px solid ${colors.primary.blue};
  }

  &::after {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    background-color: ${colors.base.white};
    opacity: ${({ status }) => (status === 'current' || status === 'todo' ? 1 : 0)};
    border-radius: 50%;
    scale: ${({ status }) => (status === 'current' || status === 'todo' ? 1 : 0)};
    ${transition}
  }
`;

export const StepLabel = styled.span<{ status: StepperStatus }>`
  display: block;
  margin-top: 8px;
  text-align: center;
  ${typography.body.medium};
  font-weight: 500;
  color: ${({ status }) => (status === 'current' ? colors.base.black : colors.primary.grey)};
  ${transition}
`;
